import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=64547da9&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=64547da9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64547da9",
  null
  
)

export default component.exports